import { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../data/network/services/ApiRequestGet";
import { BarChart } from "../../components/customBarGraph";
import { SUCCESS } from "../../resources/constantsManager";

function Graph({ width, height }) {
  const [data, setData] = useState([]);
  const getGraphData = () => {
    ApiRequestGet.getTransactionsGraph()
      .then((res) => {
        console.log(res);
        if (res.status === SUCCESS) {
          setData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getGraphData();
  }, []);

  return (
    <div
      style={{
        width: width > 1000 ? "65%" : "100%",
        border: `1px solid #E5E5E5`,
        borderRadius: 30,
        padding: 20,
        marginRight: 10,
      }}
    >
      {" "}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: 15,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 5,
          }}
        >
          <p
            style={{
              fontSize: 15,
              color: "#000000",
              opacity: 0.5,
              margin: 0,
            }}
            className="roboto"
          >
            OVERVIEW
          </p>
          <div
            style={{
              display: "flex",
            }}
          >
            <p
              style={{
                fontSize: 15,

                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#000000",
                margin: 0,
                marginLeft: 30,
              }}
              className="roboto"
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: "#C4C4C4",
                  borderRadius: 10,
                  marginRight: 10,
                }}
              ></div>{" "}
              Credited
            </p>
            <p
              style={{
                fontSize: 15,

                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#000000",
                margin: 0,
                marginLeft: 30,
              }}
              className="roboto"
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: "#6CA5FF",
                  borderRadius: 10,
                  marginRight: 10,
                }}
              ></div>{" "}
              Debited
            </p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              fontSize: 19,
              color: "#000000",
              margin: 0,
            }}
            className="roboto"
          >
            Transaction Graph
          </p>
          {/* <img
            src={Filter}
            style={{
              width: 20,
              height: 20,
              cursor: "pointer",
            }}
          /> */}
        </div>
      </div>
      <div
        style={{
          minWidth: 300,
          minHeight: 350,
          width: "100%",
        }}
      >
        <BarChart graphData={data} />
      </div>
    </div>
  );
}

export default Graph;
